import React, { useState } from 'react';

import ToasterContext from './toaster.context';

const ToasterState = props => {

    const[message, setMessage] = useState([]);

    return (<ToasterContext.Provider value={{ message, setMessage }}>{props.children}</ToasterContext.Provider>);
}

export default ToasterState;
